<template>
  <div class="nav-top">
    <div class="nav-top-left">
      <slot name="left">
        <a @click="onBackClick" class="nav-top-link" href="javascript:void(0)">
          <Icon icon-name="arrow-ios-back-outline"></Icon>
          <span>{{$t('TopNav.back')}}</span>
        </a>
      </slot>
    </div>
    <div class="nav-top-center">
      <template v-if="titleKey">{{ $t(titleKey) }}</template>
    </div>
    <div class="nav-top-right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
    import Icon from '@shared/components/Icon'

    export default {
      name: 'TopNav',
      components: { Icon },
      props: ['titleKey'],
      methods: {
        onBackClick() {
          if (window.history.length <= 1) {
            this.$router.push({ name: 'home' })
          } else {
            this.$router.back()
          }
        }
      }
    }
</script>
